<template>
  <div class="task-panel" data-testid="horizon-task-panel">
    <div
      class="task-panel__header"
      :class="{ 'task-panel__header--empty': !hasTasks }"
      data-testid="horizon-task-panel__header"
    >
      <div class="task-panel__header-text">
        <div class="task-panel__date">
          <template v-if="header.formattedDate">{{ header.formattedDate }}</template>
          <span v-else class="horizon-empty-dash" aria-hidden="true" />
        </div>
        <div class="task-panel__group">{{ header.groupLabel }}</div>
      </div>
      <lb-progress-circle
        v-if="hasTasks"
        :value="header.completionPercentage"
        :size="32"
        :width="3"
        data-testid="horizon-task-panel__progress"
      />
      <!-- <div v-else class="task-panel__progress-empty" data-testid="horizon-task-panel__progress-empty">
        <span class="horizon-empty-dash" aria-hidden="true" />
      </div> -->
    </div>

    <div class="task-panel__list" data-testid="horizon-task-panel__list">
      <div v-if="!hasTasks" class="task-panel__empty" data-testid="horizon-task-panel__empty">
        <v-icon class="task-panel__empty-icon" size="32">mdi-calendar-blank-outline</v-icon>
        <p class="task-panel__empty-title">No tasks</p>
        <p class="task-panel__empty-subtitle">{{ emptySubtitle }}</p>
      </div>
      <TaskCardDetail
        v-for="task in tasks"
        :key="task._id"
        :task="task"
        :selected="selectedTaskIds.includes(task._id)"
        @selection-change="onSelectionChange(task._id, $event)"
      />
    </div>

    <div
      v-if="selectableSelectedTaskIds.length > 0"
      class="task-panel__footer"
      data-testid="horizon-task-panel__footer"
    >
      <v-btn
        color="primary"
        block
        data-testid="horizon-task-panel__update-due-date-btn"
        @click="$emit('update-due-date')"
      >
      <img data-testid="horizon-task-panel__update-due-date-icon" src="/img/icons/fbc-icons/CalendarIcon.svg" alt="" aria-hidden="true" />
       <span data-testid="horizon-task-panel__update-due-date-text" class="ml-2">Update Due Date ({{ selectableSelectedTaskIds.length }})</span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import './TaskPanel.scss';
import TaskCardDetail from './TaskCardDetail.vue';
import { TASK_STAGES } from '../../../utils/constants';

/** Right-side panel listing tasks for the selected grid cell with bulk due-date action. */
export default {
  name: 'TaskPanel',
  components: {
    TaskCardDetail,
  },
  props: {
    header: {
      type: Object,
      default: () => ({
        groupLabel: 'All',
        formattedDate: '',
        completionPercentage: 0,
        taskCount: 0,
      }),
    },
    tasks: {
      type: Array,
      default: () => [],
    },
    selectedTaskIds: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    /** True when the selected cell has at least one task to display. */
    hasTasks() {
      return this.tasks.length > 0;
    },
    /** Empty-state message when no cell is selected vs no tasks on date. */
    emptySubtitle() {
      if (this.header.formattedDate) {
        return 'No tasks due on this date';
      }
      return 'Select a cell with tasks to view details';
    },
    /** Selected tasks eligible for due date update (excludes Approved). */
    selectableSelectedTaskIds() {
      return this.selectedTaskIds.filter((id) => {
        const task = this.tasks.find((t) => t._id === id);
        return task && task.stage !== TASK_STAGES.CLOSED;
      });
    },
  },
  methods: {
    /** Adds or removes a task id from bulk selection and emits selection-change. */
    onSelectionChange(taskId, checked) {
      const task = this.tasks.find((t) => t._id === taskId);
      if (task?.stage === TASK_STAGES.CLOSED) {
        if (checked) {
          this.$store.commit('sbError', 'Approved tasks cannot be modified');
        }
        return;
      }
      let next = [...this.selectedTaskIds];
      if (checked) {
        if (!next.includes(taskId)) next.push(taskId);
      } else {
        next = next.filter((id) => id !== taskId);
      }
      this.$emit('selection-change', next);
    },
  },
};
</script>
